const text=v=>String(v??'').trim();
const profileId=p=>text(p?.profileId||p?.id||p?.guestProfileId);
const documentId=p=>text(p?.idNumber).replace(/[^a-zA-Z0-9]/g,'').toUpperCase();
const phone=p=>text(p?.phoneNumber||p?.phone).replace(/\D/g,'');
const name=p=>text(p?.name).replace(/\s+/g,' ').toLowerCase();
// Never let a shared contact number replace a companion with another person's profile.
export function matchCompanionProfile(saved,profiles=[]) {
 const id=profileId(saved),doc=documentId(saved);
 if(id){const exact=profiles.find(p=>profileId(p)===id);if(exact)return exact;}
 if(doc){const matches=profiles.filter(p=>documentId(p)===doc);if(matches.length===1)return matches[0];return null;}
 const matches=profiles.filter(p=>name(saved)&&name(p)===name(saved)&&phone(saved)&&phone(p)===phone(saved));
 return matches.length===1?matches[0]:null;
}
